var navigation = {
    selectors: {
        dropdown: '.navigation__item--parent a'
    },
    init: function() {
    	var self = this;

        $( self.selectors.dropdown ).on( 'click', function(e) {
        	var $this = $( this );

            if ( $( e.originalEvent.target ).attr( 'href' ) === '#' ) {
                e.preventDefault();
            }

            $( document.body ).toggleClass( 'default-header' );
        	$this.parent( 'li' ).toggleClass( 'opened' );
        } );

        $( document.body ).on( 'click', function( e ) {
            if ( ! $( e.target ).closest( self.selectors.dropdown ).length ) {     
                $( document.body ).removeClass( 'default-header' );
                $( self.selectors.dropdown ).parent( 'li' ).removeClass( 'opened' );
            }
        } );

        $( window ).on( 'scroll', function( e ) {
            if ( $( document.body ).hasClass( 'default-header' ) ) {
                $( document.body ).removeClass( 'default-header' );
                $( self.selectors.dropdown ).parent( 'li' ).removeClass( 'opened' );
            }
        } );
    }
}

export {
    navigation
};
